import { getPresignedUrlApi } from 'api/attachments-api';
import { sanitizeFileNameForPresignedURL } from 'utils';

export default class FileUploadHelper {
  async getPresignedUrlFile({
    attachmentKey = '',
    fileName = '',
    fileSize = '',
    typeId = '',
    typeSlug = '',
    labelId = '',
    labelSlug = '',
    labelSourceClass = '',
    getUrlApi = null,
  }) {
    const santizedFileName = sanitizeFileNameForPresignedURL({ fileName });
    let count = 0;
    let latestError;

    while (count < 3) {
      try {
        const payload = {
          key: attachmentKey,
          file_name: santizedFileName,
          file_size: fileSize,
          type_id: typeId,
          type_slug: typeSlug,
          label_id: labelId,
          label_slug: labelSlug,
          label_source_class: labelSourceClass,
        };

        const res = await (getUrlApi ? getUrlApi(payload) : getPresignedUrlApi(payload));

        if (res?.success) {
          return res;
        }

        throw new Error('No data received from presigned URL API');
      } catch (e) {
        latestError = e;
        count += 1;
      }
    }

    throw latestError;
  }

  async uploadFileOnS3({ file = {}, s3PresignUrl }) {
    const response = await fetch(s3PresignUrl?.data?.url, {
      method: 'PUT',
      headers: s3PresignUrl?.data?.headers ?? {
        'Content-Type': file.type || 'application/octet-stream',
      },
      body: file,
    });

    if (!response.ok) {
      throw new Error(`S3 upload failed: ${response.status}`);
    }

    return response;
  }
}
